<template>
  <div v-if="payment">
    <template v-if="payment.paymentState == 'PENDING'">
      <v-alert
        v-if="payment.paymentMethod == 'CARD_ONLINE'"
        border="bottom"
        colored-border
        type="warning"
        elevation="2"
        class="my-5"
      >
        <p>
          Platba {{ $t(payment.paymentMethod) }}: {{ payment.amount / 100 }} Kč
          ještě nebyla uhrazena.
        </p>
        <v-btn @click="redirectToGateway" color="primary">
          Zaplatit {{ payment.amount / 100 }} Kč
        </v-btn>
      </v-alert>

      <v-alert
        v-else
        border="bottom"
        colored-border
        type="warning"
        elevation="2"
        class="my-5"
      >
        {{ $t(payment.paymentMethod) }}: {{ payment.amount / 100 }} Kč
      </v-alert>
    </template>

    <template v-if="payment.paymentState == 'PAID'">
      <v-alert
        border="bottom"
        colored-border
        type="success"
        elevation="2"
        class="my-5"
      >
        Platba ve výši {{ payment.amount / 100 }} Kč je uhrazena.
      </v-alert>
    </template>

    <template v-if="payment.paymentState == 'AUTHORIZED'">
      <v-alert
        border="bottom"
        colored-border
        type="success"
        elevation="2"
        class="my-5"
      >
        Platba ve výši {{ payment.amount / 100 }} Kč je autorizována.
      </v-alert>
    </template>

    <template v-if="payment.paymentState == 'CANCELLED'">
      <v-alert
        border="bottom"
        colored-border
        type="warning"
        elevation="2"
        class="my-5"
      >
        Platba ve výši {{ payment.amount / 100 }} Kč byla stornována.
      </v-alert>
    </template>
  </div>

  <div v-else>
    <v-alert
      border="bottom"
      colored-border
      type="warning"
      elevation="2"
      class="my-5"
    >
      Platbu s jsme nenašli.
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "PaymentSummary",

  props: {
    payment: {
      type: Object,
    },
  },

  methods: {
    redirectToGateway() {
      window.location.href = this.payment.redirectUrl;
    },
  },
};
</script>
